// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-brand {
  margin-top: 16px;
  margin-bottom: 10px;
  margin-left: 12px;
}
.logo-brand span {
  margin-top: 2px;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  text-transform: uppercase;
  color: #121b2b;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
}
.logo-brand span span {
  color: #1ba192;
}

.sidebar-minimizer {
  margin-right: 10px !important;
}

.user-image-custom {
  background: #ffffff;
  border-radius: 50%;
  width: 37px;
  height: 37px;
  float: right;
  padding: 2px;
  margin-top: 3px;
}

.user-iamge-toggle {
  position: relative;
  bottom: 12px;
  left: 30px;
}

.padding-right-0px {
  padding-right: 0px;
}

.user-info {
  padding-left: 5px;
  background-color: #f7f7f7;
}

.user-info-toggle {
  background-color: white;
}

.user-avatar {
  text-align: center;
  margin-top: 10px;
}
.user-avatar .user-name-custom {
  font-size: 14px;
  line-height: 15px;
  height: 15px;
  left: 71px;
  top: 78px;
  color: #1a273c;
  margin-bottom: 5px;
  margin-top: 5px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
}
.user-avatar .user-company-custom {
  height: 13px;
  left: 71px;
  top: 94px;
  text-align: center;
  font-weight: normal;
  font-size: 12px;
  line-height: 13px;
  /* identical to box height */
  /* Gray / 4 */
  color: #999999;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
}

.user-details {
  margin-top: 15px;
}
.user-details div {
  text-align: center;
  margin-bottom: 15px;
}
.user-details div p {
  margin-top: 10px;
  margin-bottom: 0px;
  height: 11px;
  font-weight: normal;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */
  /* Gray / 2 */
  color: #333333;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
}
.user-details div i {
  color: #666666;
}
.user-details .custom-border {
  border-right: 1px solid #e6e6e6;
}

.width-50 {
  width: 50%;
}

.width-40 {
  width: 40%;
}

.width-60 {
  width: 60%;
}

.custom-img {
  width: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/containers/components/app-sidebar-header/app-sidebar-header.component.scss"],"names":[],"mappings":"AAKA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AAJF;AAME;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EAfF,qCAAA;EACA,kBAAA;AAYF;AAMI;EACE,cAAA;AAJN;;AASA;EACE,6BAAA;AANF;;AASA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AANF;;AASA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AANF;;AASA;EACE,kBAAA;AANF;;AAQA;EACE,iBAAA;EACA,yBAAA;AALF;;AAOA;EACE,uBAAA;AAJF;;AAMA;EACE,kBAAA;EACA,gBAAA;AAHF;AAKE;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EApEF,qCAAA;EACA,kBAAA;AAkEF;AAME;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,aAAA;EACA,cAAA;EApFF,qCAAA;EACA,kBAAA;AAgFF;;AASA;EACE,gBAAA;AANF;AAOE;EACE,kBAAA;EACA,mBAAA;AALJ;AAOI;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,aAAA;EACA,cAAA;EA1GJ,qCAAA;EACA,kBAAA;AAqGF;AASI;EACE,cAAA;AAPN;AAUE;EACE,+BAAA;AARJ;;AAYA;EACE,UAAA;AATF;;AAWA;EACE,UAAA;AARF;;AAUA;EACE,UAAA;AAPF;;AAUA;EACE,WAAA;AAPF","sourcesContent":["@mixin colorVsFont {\n  font-family: \"Montserrat\", sans-serif;\n  font-style: normal;\n}\n\n.logo-brand {\n  margin-top: 16px;\n  margin-bottom: 10px;\n  margin-left: 12px;\n\n  span {\n    margin-top: 2px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 18px;\n    text-transform: uppercase;\n    color: #121b2b;\n\n    @include colorVsFont;\n\n    span {\n      color: #1ba192;\n    }\n  }\n}\n\n.sidebar-minimizer {\n  margin-right: 10px !important;\n}\n\n.user-image-custom {\n  background: #ffffff;\n  border-radius: 50%;\n  width: 37px;\n  height: 37px;\n  float: right;\n  padding: 2px;\n  margin-top: 3px;\n}\n\n.user-iamge-toggle {\n  position: relative;\n  bottom: 12px;\n  left: 30px;\n}\n\n.padding-right-0px {\n  padding-right: 0px;\n}\n.user-info {\n  padding-left: 5px;\n  background-color: #f7f7f7;\n}\n.user-info-toggle {\n  background-color: white;\n}\n.user-avatar {\n  text-align: center;\n  margin-top: 10px;\n\n  .user-name-custom {\n    font-size: 14px;\n    line-height: 15px;\n    height: 15px;\n    left: 71px;\n    top: 78px;\n    color: #1a273c;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    text-align: center;\n\n    @include colorVsFont;\n  }\n\n  .user-company-custom {\n    height: 13px;\n    left: 71px;\n    top: 94px;\n    text-align: center;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 13px;\n    /* identical to box height */\n\n    /* Gray / 4 */\n    color: #999999;\n\n    @include colorVsFont;\n  }\n}\n\n.user-details {\n  margin-top: 15px;\n  div {\n    text-align: center;\n    margin-bottom: 15px;\n\n    p {\n      margin-top: 10px;\n      margin-bottom: 0px;\n      height: 11px;\n      font-weight: normal;\n      font-size: 10px;\n      line-height: 11px;\n      /* identical to box height */\n\n      /* Gray / 2 */\n      color: #333333;\n\n      @include colorVsFont;\n    }\n\n    i {\n      color: #666666;\n    }\n  }\n  .custom-border {\n    border-right: 1px solid #e6e6e6;\n  }\n}\n\n.width-50 {\n  width: 50%;\n}\n.width-40 {\n  width: 40%;\n}\n.width-60 {\n  width: 60%;\n}\n\n.custom-img {\n  width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
